module.exports = __webpack_public_path__ + "static/media/companylogo.be74625b.svg";